import { createSlice } from '@reduxjs/toolkit';
import { findPartnerAuditLog } from './api';
import { initialState } from './api/interface';

const partnerAuditLogSlice = createSlice({
  name: 'partnerAuditLog',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
      state.skip = 0;
      state.currentPage = 0;
      state.status = 'idle';
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findPartnerAuditLog.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findPartnerAuditLog.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.totalRecords = action.payload.total;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findPartnerAuditLog.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
  },
});

export const {
  setLimit,
  setSkip,
  setCurrentPage,
  setStatus,
  setFilters,
  reset,
} = partnerAuditLogSlice.actions;
export default partnerAuditLogSlice.reducer;
